module.exports = __webpack_public_path__ + "img/company.7d823ae2.png";